import React, { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

function NewsUpdate() {
  const [loading, setLoading] = useState(false);
  const [loadingtwo, setLoadingtwo] = useState(false);
  const [loadingthree, setLoadingthree] = useState(false);
  const navigate = useNavigate(); 

  const saveUrl = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate("/add-compliance"); 
    }, 2000); 
  };

  const saveUrltwo = () => {
    setLoadingtwo(true);
    setTimeout(() => {
      setLoadingtwo(false);
      navigate("/update-compliance"); 
    }, 2000); 
  };

  const saveUrlthree = () => {
    setLoadingthree(true);
    setTimeout(() => {
      setLoadingthree(false);
      navigate("/delete-compliance"); 
    }, 2000); 
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-700 rounded-lg">
      <div className="p-8 mt-10 w-full max-w-lg bg-gray-100 shadow-2xl rounded-3xl text-center border border-gray-300">
        {/* Heading */}
        <motion.h2
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-3xl font-bold text-gray-900 bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-500"
        >
          Compliance
        </motion.h2>

        {/* First Button & Loader */}
        {!loading ? (
          <motion.button
            onClick={saveUrl}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 250 }}
            className="w-full mt-6 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold py-3 rounded-xl shadow-md transition-all duration-300 hover:scale-105 hover:shadow-xl"
          >
            Add Compliance
          </motion.button>
        ) : (
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
            className="w-8 h-8 border-4 border-t-transparent border-blue-600 rounded-full mx-auto mt-6"
          ></motion.div>
        )}

        {/* Second Button & Loader */}
        {!loadingtwo ? (
          <motion.button
            onClick={saveUrltwo}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 250 }}
            className="w-full mt-6 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold py-3 rounded-xl shadow-md transition-all duration-300 hover:scale-105 hover:shadow-xl"
          >
            Edit / Update Compliance
          </motion.button>
        ) : (
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
            className="w-8 h-8 border-4 border-t-transparent border-blue-600 rounded-full mx-auto mt-6"
          ></motion.div>
        )}

         {/* Third Button & Loader */}
         {!loadingthree ? (
          <motion.button
            onClick={saveUrlthree}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 250 }}
            className="w-full mt-6 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold py-3 rounded-xl shadow-md transition-all duration-300 hover:scale-105 hover:shadow-xl"
          >
            Delete Compliance
          </motion.button>
        ) : (
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
            className="w-8 h-8 border-4 border-t-transparent border-blue-600 rounded-full mx-auto mt-6"
          ></motion.div>
        )}
      </div>
    </div>
  );
}

export default NewsUpdate;
